import { render, staticRenderFns } from "./ProductCardNewPopup.vue?vue&type=template&id=28459e51&"
import script from "./ProductCardNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProductCardNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports